import React, { useEffect } from 'react';
import { useDispatch } from 'react-redux';

import ForbiddenPage from '../../Page/ForbiddenPage';

import InterestUri from '../../Enum/InterestUri';

import { isTokenValid } from '../../Hook/Interest/UseAuthentication';
import useGetEngine from '../../Hook/UseGetEngine';
import { getApiUrl } from '../../Service/ApiService';
import { redirectRequested } from '../../Store/Redirect/action';

const Login: React.FC = () => {
    const dispatch = useDispatch();
    const validToken = isTokenValid();
    const { isViisi, isProductPropertiesOnly } = useGetEngine();

    useEffect(() => {
        if (isViisi()) {
            const url = validToken ? `/rente/${InterestUri.PropertiesPerLabel}` : `${getApiUrl()}sso/viisi`;
            dispatch(redirectRequested(url));
            return;
        }

        if (validToken) {
            const route = isProductPropertiesOnly() ? InterestUri.PropertiesPerLabel : InterestUri.FixedPeriod;
            dispatch(redirectRequested(`/rente/${route}`));
        }
    }, []);

    return <ForbiddenPage />;
}

export default Login;
